<template>
  <div class="rechargerecordNew">
    <div class="section">
      <!-- 查询 -->
      <div class="search">
        <div>
          <!-- 流量状态 -->
          <span class="search-label">{{ $t('recharge.Traffic_status') }}</span>
          <!-- :placeholder="$t('recharge.Traffic_status')" -->
          <!-- :placeholder="this.$t('datalogger.Datalogger_Status')" -->
          <el-select
            v-model="searchDatalogger.status"
            @change="queryData(true)"
            size="small"
            :placeholder="this.$t('header.pleaseSelect')"
            popper-class="select-search-recharge"
            class="selectClearNew"
            clearable
          >
            <el-option
              v-for="(val, key) in dataloggerStatus"
              :key="key"
              :label="val.label"
              :value="key"
              style="display:flex;align-items:center;"
              class="choose-status"
            >
              <i style="width:10px;height:10px;margin-right:8px;" :class="`status-${val.class}`"></i>
              <span class="select-label">{{ val.label }}</span>
            </el-option>
          </el-select>
          <!-- 带载数 -->
          <span class="search-label">{{ $t('recharge.load') }}</span>
          <!-- :placeholder="$t('recharge.load')" -->
          <el-select
            v-model="searchDatalogger.load"
            @change="queryData(true)"
            :placeholder="this.$t('header.pleaseSelect')"
            size="small"
            popper-class="select-search-recharge"
            class="selectClearNew"
            clearable
          >
            <el-option
              v-for="item in 10"
              :key="item"
              :label="item"
              :value="item"
              class="choose-num"
            ></el-option>
          </el-select>
          <!-- 套餐类型 -->
          <span class="search-label">{{ $t('recharge.Package_type') }}</span>
          <el-select
            v-model="searchDatalogger.cardType"
            @change="queryData(true)"
            :placeholder="this.$t('header.pleaseSelect')"
            size="small"
            popper-class="select-search-recharge"
            class="selectClearNew"
            clearable
          >
            <el-option :label="'2G'+this.$t('recharge.domestic')"  :value="0" class="choose-num"></el-option>
            <el-option :label="'2G'+this.$t('recharge.abroad')" :value="2" class="choose-num"></el-option>
            <el-option :label="'4G'+this.$t('recharge.domestic')" :value="1" class="choose-num"></el-option>
            <el-option :label="'4G'+this.$t('recharge.abroad')" :value="3" class="choose-num"></el-option>
          </el-select>
        </div>
        <!-- 搜索 -->
        <!-- showSearch = true; -->
        <el-button class="button button-solid" @click.stop="showSearchBtn">
          <i class="el-icon-search"></i>
        </el-button>
        <!-- v-clickoutside="closeSearch2" -->
        <div class="search-alert" v-show="showSearch">
          <!-- :placeholder="$t('recharge.pn')" -->
          <!-- v-model="inputText" -->
          <div class="searchDiv">
            <el-input
              class="searchAll"
              ref="iptFocus"
              v-model.trim="searchDatalogger.alias"
              @keyup.enter.native="queryData(true)"
              :placeholder="this.$t('datalogger.Datalogger_PN')"
              clearable
            >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <!-- 搜索 -->
            <span class="search-device" @click="queryData(true)">{{ $t('recharge.Search') }}</span>
            <!-- 取消 -->
            <span class="search-hide" @click="closeSearch">{{ $t('datalogger.cancel') }}</span>
          </div>
        </div>

        <!-- 批量操作弹条 (显隐由是否勾选决定) -->
        <!-- v-show="showBatch" -->
        <!-- v-show="selectedDatalogger.length" -->
        <!-- v-show="false" -->
        <div class="batch-alert" v-show="selectedDatalogger.length">
          <!-- 当前选中条数 -->
          <span
            class="batch-total"
          >{{ `${$t('alarm.curSelected')} ${selectedDatalogger.length} ${$t('alarm._Data')}` }}</span>
          <div class="batch-right">
            <!-- 操作 -->
            <span class="batch-operate">
              <!-- 充值 -->
              <span class="btn" @click="openRecharge(selectedDatalogger)">
                {{ $t('recharge.Recharge_Selected') }}
                <i class="ico ico-pay"></i>
              </span>
            </span>
            <!-- 取消 -->
            <span class="batch-hide" @click="closeBatch">{{ $t('rate.cancel') }}</span>
          </div>
        </div>
      </div>
      <!-- 表格 -->
      <!-- border -->
      <el-table
        height="100%"
        class="tablemain tableloding"
        border
        v-loading="elLoading"
        :data="dataloggerList"
        stripe
        :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }"
        element-loading-spinner="el-icon-loading"
        @selection-change="handleSelectionChange"
        :empty-text="$t('account.nodata')"
        ref="multiplePayTable"
      >
        <!-- :empty-text="$t('message.nodata')" -->
        <el-table-column fixed type="selection" width="55px"></el-table-column>
        <el-table-column
          fixed
          prop="pn"
          min-width="140px"
          :label="this.$t('recharge.Datalogger_PN')"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          min-width="180"
          prop="ccid"
          :label="this.$t('recharge.CCID')"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          min-width="90"
          :label="this.$t('recharge.Plant')"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span :title="scope.row.plant || '--'">{{ scope.row.plant || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="90" prop="gprsType" :label="this.$t('recharge.recharge_type')" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column min-width="120" prop="serviceArea" :label="this.$t('recharge.Service_Area')" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.serviceArea==1">{{$t('recharge.area_domestic')}}</span>
            <span v-else-if="scope.row.serviceArea==2">{{$t('recharge.area_abroad')}}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="80"
          prop="load"
          :label="this.$t('recharge.Connecting_Devices')"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          min-width="105"
          prop="gprsStatus"
          :label="this.$t('recharge.Status')"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span
              v-if="scope.row.gprsStatus !== undefined"
              :class="`color-${dataloggerStatus[scope.row.gprsStatus].class}`"
            >
              {{ dataloggerStatus[scope.row.gprsStatus] ?
              dataloggerStatus[scope.row.gprsStatus].label : '' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="datFetch"
          min-width="80"
          :label="this.$t('recharge.Signal')"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <signal :strength="scope.row.datFetch"></signal>
          </template>
        </el-table-column>
        <el-table-column
          min-width="155"
          :label="this.$t('recharge.Activation_Time')"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span :title="scope.row.adate || '--'">{{ scope.row.adate || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="155"
          :label="this.$t('recharge.Dead_Time')"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span :title="scope.row.edate || '--'">{{ scope.row.edate || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="this.$t('recharge.Operation')"
          fixed="right"
          width="100"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              class="operation"
              :title="$t('recharge.Recharge')"
              @click="openRecharge([scope.row])"
            >
              <!-- <i class="iconfont icon-recharge"></i> -->
              <i class="ico ico-recharge"></i>
            </el-button>
          </template>
        </el-table-column>
        <!-- 无数据 -->
        <!-- <div v-show="emptyText" slot="empty"><img src="@/assets/img/empty_text.png"/>
        <div style="line-height: 32px">{{$t('account.nodata')}}</div></div>-->
      </el-table>
      <!-- 分页 -->
      <div class="tablebottom">
        <!-- 批量占位 -->
        <div class style="margin-left:10px;">
          <!-- 充值多选 -->
          <!-- <button
            style="height:32px;margin-left:16px;"
            class="btn"
            :class="selectedDatalogger.length ? 'btn-dark' : 'btn-disable'"
            @click="openRecharge(selectedDatalogger)"
          >{{$t('recharge.Recharge_Selected')}}</button>-->
        </div>
        <!-- 分页 -->
        <!-- v-show="paginationRecharge" -->
        <!-- jumper -->
        <el-pagination
          class="pagination"
          background
          @size-change="queryData(true)"
          @current-change="() => queryData()"
          :current-page.sync="pagination.currentPage"
          :page-sizes="[10, 15, 20, 30, 50]"
          :page-size.sync="pagination.pagesize"
          layout="slot, sizes, total, pager, prev, next, jumper"
          :total="pagination.total"
          popper-class="select-page"
        >
          <span style="color:#ffffff;padding-left:15px;">{{ $t('device.pageSize') }} :</span>
        </el-pagination>
      </div>
    </div>
    <!-- 充值对话框(new) -->
    <!-- v-if="showRechargeDialog" -->
    <!-- :class="{'showDialog': showRechargeDialog, 'hideDialog': !showRechargeDialog}" -->
    <recharge-dialog
      :title="$t('menu.pay')"
      :visible.sync="showRechargeDialog"
      class="dialog-recharge"
      v-if="showRechargeDialog"
      width="780px"
      noFooter
    >
      <!-- v-if="currentStep===1" -->
      <el-form
        ref="form"
        :label-width="this.$lang.currentLang == 'zh_CN'||this.$lang.currentLang == 'en_US'||this.$lang.currentLang == 'en_ID'?'100px':'160px'"
        slot="content"
        class="step-one"
        v-if="currentStep === 1"
      >
        <!-- 充值设备 -->
        <el-form-item :label="$t('recharge.rechargeDevice')">
          <!-- {{rechargingInfo.pn}} -->
          <el-tag
            v-for="(item, index) in rechargingInfo.pn"
            :key="item"
            :closable="rechargingInfo.pn.length > 1"
            @close="rechargingInfo.pn.splice(index, 1)"
            type="info"
            class="tag"
          >{{ item }}</el-tag>
        </el-form-item>
        <!-- 充值套餐 -->
        <el-form-item :label="$t('recharge.rechargePackage')">
          <span
            v-for="(item,index) in availablePackages"
            :key="index"
            class="package"
            :class="{ selected: rechargingInfo.package === item }"
            @click="rechargingInfo.package = item"
          >
            {{ item.duration }}
            <br />
            {{ item.label }}
          </span>
        </el-form-item>
        <!-- 支付方式 -->
        <el-form-item :label="$t('recharge.rechargeChannel')">
          <div class="payment-method-row">
            <div class="payment-method-card" :class="{active: PaymentMethod === 0}" @click="PaymentMethodClick(0)">
              <img src="../../../assets/img/recharge/weixin.png" class="payment-icon" alt="">
              <div class="payment-info">
                <div class="payment-name">
                  <span>{{$t('recharge.Recharge_tip5')}}</span>
                  <span class="paybaseShow" :class="{payChoose: PaymentMethod === 0}"></span>
                </div>
                <div class="payment-desc">{{$t('recharge.Recharge_tip3')}}</div>
              </div>
            </div>
            <div class="payment-method-card" :class="{active: PaymentMethod === 5}" @click="PaymentMethodClick(5)">
              <img src="../../../assets/img/recharge/paypal.png" class="payment-icon" alt="">
              <div class="payment-info">
                <div class="payment-name">
                  <span>Pay pal</span>
                  <span class="paybaseShow" :class="{payChoose: PaymentMethod === 5}"></span>
                </div>
                <div class="payment-desc">{{$t('recharge.Recharge_tip4')}}</div>
              </div>
            </div>
          </div>
        </el-form-item>
        <!-- 充值方式(旧) -->
        <!-- <el-form-item :label="$t('recharge.rechargeChannel')">
          <div
            v-for="item in availableChannels"
            :key="item.name"
            class="capsule-wrapper"
            :class="{selected: rechargingInfo.channel===item}"
            @click="rechargingInfo.channel=item"
          >
            <div class="capsule-content">
              <img :src="item.img" :alt="item.name" />
            </div>
          </div>
        </el-form-item>-->
        <!-- 优惠 -->
        <!-- <el-form-item :label="$t('recharge.rechargeDiscount')">
          <span
            class="discount"
          >￥&nbsp;{{rechargingInfo.package.discount * rechargingInfo.pn.length}}</span>
        </el-form-item>-->
        <!-- 金额 -->
        <!-- <el-form-item :label="$t('recharge.rechargePrice')">
          <span
            class="price"
          >￥&nbsp;{{rechargingInfo.package.finalPrice * rechargingInfo.pn.length}}</span>
        </el-form-item>-->
        <div class="settlementbox">
          <!-- <img src="@/assets/img/appDownload.png" style="width:148px;height:148px;"/> -->
          <span class="settlementinfo">
            <!-- 支付 -->
            <span class="settlementnum">
              {{ `${$t('recharge.rechMoney')}&nbsp;${currencySymbol}&nbsp;${rechargingInfo.package.finalPrice *
              rechargingInfo.pn.length}` }}
            </span>
            <!-- 已优惠 -->
            <span class="settlementnum">
              {{ `${$t('recharge.rechDiscount')}&nbsp;${currencySymbol}&nbsp;${rechargingInfo.package.discount *
              rechargingInfo.pn.length}` }}
            </span>
            <!-- 请打开手机微信扫一扫完成支付 -->
            <!-- <span class="settlementscan">{{$t('recharge.rechScan')}}</span> -->
            <!-- 温馨提示：1、同一订单只能选择相同带载数和相同扶贫平台状态的设备(默认显示带载数为1和未接入扶贫平台的套餐)；
            2、充值逾期卡和在每月25号至5号进行充值都会延迟1~14天到帐，请耐心等待-->
            <span class="settlementtip">{{ $t('recharge.rechTip') }}</span>
          </span>
        </div>
        <div style="text-align:right;margin-top:30px;">
          <button
            type="button"
            class="btn btn-light"
            style="margin-right:10px;"
            @click="closeRechargeDialog"
          >
            {{
            $t('recharge.cancel') }}
          </button>
          <!-- type="button" | el-button -->
          <button type="button" class="btn btn-dark" @click="confirmPay">
            {{ $t('recharge.confirm')
            }}
          </button>
          <!-- <el-button class="btn btn-dark" @click="confirmPay">{{$t('recharge.confirm')}}</el-button> -->
        </div>
      </el-form>
      <!-- 选择充值支付方式(已合并到step1) -->
      <!-- 生成与扫码 -->
      <div v-if="currentStep === 2" slot="content" class="step-two">
        <!-- <p class="prompt">{{$t('recharge.scan')}}</p> -->
        <p class="price">{{ currencySymbol }}{{ rechargingInfo.package.finalPrice * rechargingInfo.pn.length }}</p>
        <div class="qr" ref="qr"></div>
        <p class="info" v-if="PaymentMethod ==0">{{ $t('recharge.openWx') }}</p>
        <p class="info">{{ $t('recharge.scanComplete') }}</p>
      </div>
      <!-- 充值成功 -->
      <div slot="content" class="step-three" v-if="currentStep === 3">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('recharge.Recharge_successful') }}</span>
          <button class="button-solid showresultbtn" @click="goRechargeRecord">
            {{ $t('recharge.Recharge_record')
            }}
          </button>
        </div>
      </div>
      <!-- 充值失败 -->
      <div slot="content" class="step-three" v-if="currentStep === 4">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresultname">{{ errorMsgTip }}</span>
          <button class="button-solid showresultbtn" @click="goRechargeRecord">
            {{ $t('recharge.Recharge_record')
            }}
          </button>
        </div>
      </div>
      <!-- <div slot="footer">
        <div v-if="currentStep===1">
          <button class="button-hollow" @click="closeRechargeDialog">{{$t('recharge.cancel')}}</button>
          <button class="button-solid" @click="confirmPay">{{$t('recharge.confirm')}}</button>
        </div>
        <div v-if="currentStep===2">
          <button class="button-hollow" @click="currentStep=1">{{$t('recharge.previous')}}</button>
        </div>
        <div v-if="currentStep===3">
          <button class="button-solid" @click="closeRechargeDialog">{{$t('createPlant.close')}}</button>
        </div>
      </div>-->
    </recharge-dialog>
    <!-- 批量充值规格不一样拦截 -->
    <rechargeErr-dialog
      :title="$t('recharge.Recharge_tip')"
      :visible.sync="showRechargeErrDialog"
      v-if="showRechargeErrDialog"
      :class="{ 'showDialog': showRechargeErrDialog, 'hideDialog': !showRechargeErrDialog }" width="30vw" noFooter
    >
    <div class="content_tishi" slot="content">
        <div class="tital">
          <span class="contentdelete" style="width:100%;text-align:left;color: #fff;">{{ $t('recharge.Recharge_tip1') }}</span>
        </div>
        <div class="disabledescr" style="margin-top: 10px;">
          <span style="width:100%;text-align:left;color: #929294;">{{ $t('recharge.Recharge_tip2') }}</span>
        </div>
        <div class="deletfotter" style="text-align:right;margin-top:28px;">
          <button type="button" class="btn btn-dark" @click="showRechargeErrDialog = false">{{
            $t('firmware.confirm') }}</button>
        </div>
      </div>
    </rechargeErr-dialog>
    <!-- 暂不支持充值 -->
    <rechargeErr-dialog
      :title="$t('recharge.Recharge_tip')"
      :visible.sync="showRechargeElseErrDialog"
      v-if="showRechargeElseErrDialog"
      :class="{ 'showDialog': showRechargeElseErrDialog, 'hideDialog': !showRechargeElseErrDialog }" width="30vw" noFooter
    >
    <div class="content_tishi" slot="content">
        <div class="tital">
          <span class="contentdelete" style="width:100%;text-align:left;color: #fff;">{{ $t('recharge.Recharge_tip6') }}</span>
        </div>
        <div class="deletfotter" style="text-align:right;margin-top:28px;">
          <button type="button" class="btn btn-dark" @click="showRechargeElseErrDialog = false">{{
            $t('firmware.confirm') }}</button>
        </div>
      </div>
    </rechargeErr-dialog>
  </div>
</template>
<script>
import wxpayImg from "@/assets/img/wxpay.png";
import rechargeErrDialog from "@/components/dialognew";
import rechargeDialog from "@/components/dialognew/flowIndex";
import signal from "@/components/signalnew";
import QRCode from "qrcodejs2";
import { mapState } from "vuex";
import { i18n } from "@/i18n";
import filter from "@/assets/js/filter";
export default {
  components: {
    rechargeDialog,
    rechargeErrDialog,
    signal
  },
  data() {
    return {
      // 判断是否有权限，之前的经销商不存在权限
      disPermissionsLogo:sessionStorage.getItem("disPermissionsLogo")?JSON.parse(sessionStorage.getItem("disPermissionsLogo")):false,
      // 页面权限集合
      btnList: sessionStorage.getItem("buttonArr")?JSON.parse(sessionStorage.getItem("buttonArr")):[],
      payBtnDisabled: false,
      PaymentMethod: 0,
      showRechargeElseErrDialog: false,
      showRechargeErrDialog: false,
      emptyTextElse: false,
      emptyText: false,
      paginationRecharge: false,
      paginationPay: false,
      activeName: this.$route.query.tab || "info",
      searchDatalogger: {
        status: "",
        pn: "",
        load: "",
        cardType: "",
        ccid: "",
        alias: ""
      },
      pagination: {
        currentPage: 1,
        pagesize: 15,
        // 默认 0
        total: 100
      },
      // 数采器状态列表
      dataloggerStatus: {
        0: {
          class: "normal",
          label: this.$t("recharge.normal")
        },
        1: {
          class: "warning",
          label: this.$t("recharge.warning")
        },
        2: {
          class: "standby",
          label: this.$t("recharge.Overdue")
        },
        3: {
          class: "offline",
          label: this.$t("recharge.expired")
        },
        4: {
          class: "fault",
          label: this.$t("recharge.unknown")
        }
      },
      dataloggerList: [],
      showRechargeDialog: false,
      rechargingInfo: null,
      selectedDatalogger: [],
      // 可选套餐列表
      availablePackages: [],
      // 可选充值方式列表
      availableChannels: [
        {
          name: "wxpay",
          value: 0,
          img: wxpayImg
        },
        // {
        //   name: 'alipay',
        //   value: 1,
        //   img: alipayImg
        // }
        {
          name: "paypal",
          value: 5,
          // img: wxpayImg
        }
      ],
      // 当前充值步骤
      currentStep: 1,
      // 轮询扫码结果
      orderResultPolling: null,
      searchRecharge: {
        pn: "",
        status: ""
      },
      elLoading: false,
      isLoading: false,
      paginations: {
        currentPage: 1,
        pagesize: 15,
        total: 0
      },
      rechargeList: [],
      // 订单状态列表
      rechargeStatus: {
        0: {
          class: "offline",
          label: this.$t("recharge.Unpaid")
        },
        1: {
          class: "warning",
          label: this.$t("recharge.Paid")
        },
        2: {
          class: "normal",
          label: this.$t("recharge.Recharged")
        },
        3: {
          class: "standby",
          label: this.$t("recharge.Recharging")
        }
      },
      // 搜索弹出
      showSearch: false,
      // 搜索内容
      inputText: "",
      // 弹框提示信息
      errorMsgTip: ""
    };
  },
  mounted() {
    this.queryData();
  },
  computed: {
    ...mapState({
      // 角色
      role: state => {
        return {
          id: state.user.role,
          name: filter.role(state.user.role).name,
          group: filter.role(state.user.role).group
        };
      }
    }),
    currencySymbol() {
      return this.PaymentMethod === 5 ? '$' : '￥';
    }
  },
  watch: {
    showRechargeDialog(val) {
      if (!val) {
        this.currentStep = 1;
        this.rechargingInfo = null;
      }
    },
    currentStep(val) {
      // 清除轮询
      if (val !== 2) {
        clearInterval(this.orderResultPolling);
        this.orderResultPolling = null;
      }
    },
    "$route.query.tab"(val) {
      this.activeName = val || "info";
    }
  },
  methods: {
    //获取列表数据
    queryData(reset) {
      this.paginationRecharge = false;
      if (reset) this.pagination.currentPage = 1;
      let param = {
        page: this.pagination.currentPage - 1,
        pagesize: this.pagination.pagesize,
        cardStatus: this.searchDatalogger.status,
        ccid: this.searchDatalogger.ccid,
        load: this.searchDatalogger.load,
        alias: this.searchDatalogger.alias,
        cardType: this.searchDatalogger.cardType,
        type: 0
      };
      this.elLoading = true;
      this.$request.get("webQueryGprsCollector", param).then(res => {
        if (res.err == 0) {
          this.dataloggerList = res.dat.collector;
          this.pagination.total = res.dat.total;
          if (this.pagination.total > this.pagination.pagesize) {
            this.paginationRecharge = true;
          }
        } else {
          // this.$message.error(this.$t(`errCode.${res.err}`));
          this.emptyText = true;
          this.dataloggerList = [];
          this.pagination.total = 0;
        }
        this.elLoading = false;
      });
    },
    // 切换数采器列表选中项
    handleSelectionChange(selection) {
      this.selectedDatalogger = selection;
    },
    // 查询套餐并打开充值弹窗
    fetchPackagesAndOpen(rechargingInfo) {
      this.$request
        .getDEVMicroservices("/ros/api/flow/package/pub/queryGprsRechargeTariffPackage", {
          ctype: rechargingInfo.load,
          cardType: rechargingInfo.cardType,
          'operators': 'CMCC',
          'systemType': '1',
          payWay: this.PaymentMethod,
          i18n: this.$lang.currentLang
        })
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            let packages = [];
            res.data.forEach(item => {
              let arr = item.name.split("/");
              packages.push({
                label: arr[0],
                duration: arr[1],
                discount: item.discount,
                finalPrice: item.sellPrice,
                number: item.number
              });
            });
            this.availablePackages = packages;
            rechargingInfo.package = packages.length && packages[0];
            rechargingInfo.channel = this.PaymentMethod;
            this.rechargingInfo = rechargingInfo;
            this.showRechargeDialog = true;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    // 打开充值弹窗
    openRecharge(dataloggers) {
      if(this.disPermissionsLogo&&!this.btnList.includes('data_recharge_button')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      // 先判断带载数是否一致
      let initialInfo = {
        type: dataloggers[0].type ? 1 : 0,
        load: dataloggers[0].load,
        cardType: dataloggers[0].cardType,
        pn: [],
        ccid: []
      };
      let rechargingInfo = dataloggers.reduce((total, item) => {
        let result = false;
        if (total && item.load === total.load&&item.cardType === total.cardType) {
          total.pn.push(item.pn);
          total.ccid.push(item.ccid);
          result = total;
        }
        return result;
      }, initialInfo);
      if (!rechargingInfo) {
        this.showRechargeErrDialog = true;
        return false;
      }
      dataloggers.forEach(item => {
        // 在判断类型是否为2G
        if (item.gprsType == "2G") {
          this.$confirm(
            `${this.$t("recharge.Hint_language")}`,
            `${this.$t("recharge.Tips")}`,
            {
              confirmButtonText: this.$t("recharge.Confirm_recharge"),
              cancelButtonText: this.$t("recharge.Cancel_recharge"),
              type: "warning"
            }
          )
            .then(() => {
              if (!dataloggers.length) return false;
              this.fetchPackagesAndOpen(rechargingInfo);
            })
            .catch(() => {
              this.showRechargeDialog = false;
            });
        } else {
          if (!dataloggers.length) return false;
          this.fetchPackagesAndOpen(rechargingInfo);
        }
      });
      console.log(this.rechargingInfo)
    },
    //点击确定提交充值订单
    conRechargeMethod(){
      console.log(this.rechargingInfo)
      // 点击一次提交后禁用该按钮以防止用户连续点击提交
      if (!this.payBtnDisabled) {
        this.payBtnDisabled = true;
      }
      // 参数
      let param = {
        packageNumber: this.rechargingInfo.package.number,
        // channel: this.rechargingInfo.channel.value,
        'systemType': 1,
        // payChannel: this.rechargingInfo.channel,
        payChannel: this.PaymentMethod,
        payScene: 0,
        // pn: this.rechargingInfo.pn.join(","),
        pns: this.rechargingInfo.pn,
        ccids: this.rechargingInfo.ccid,
        // imsis:
        // type: this.rechargingInfo.type,
        load: this.rechargingInfo.load,
      };
      // gprsRechargeQrCodeNew
      this.$request.postDEVMicroservices("/ros/api/flow/order/createRecharge", param).then(res => {
        console.log(res)
        if (res.code === 0 && res.data.url) {
          this.currentStep = 2;
          this.$nextTick(() => {
            // 生成二维码图片
            new QRCode(this.$refs.qr, {
              text: res.data.url, // 二维码url
              width: 180,
              height: 180
            });
            // 轮询扫码结果
            this.orderResultPolling && clearInterval(this.orderResultPolling);
            this.orderResultPolling = setInterval(() => {
              this.$request
                .getDEVMicroservices("/ros/api/flow/order/pub/queryRechargeOrderDetails", {
                  orderNo: res.data.orderno
                })
                .then(res => {
                  if (res.code === 0 && (res.data.payStatus == 2 || res.data.payStatus == 6)) {
                    this.currentStep = 3;
                    var qrcodeElement = this.$refs.qr;
                    while (qrcodeElement.firstChild) {
                      qrcodeElement.removeChild(qrcodeElement.firstChild);
                    }
                  }
                });
            }, 2000);
          });
        } else {
          // this.errorMsgTip = this.$t(`errCode.${res.err}`);
          this.errorMsgTip = res.message;
          this.$notify({
            title: `${this.$t("recharge.Tips")}`,
            message: `${this.$t("recharge.Hint_language1")}`,
            position: "bottom-right"
          });
          this.currentStep = 4;
        }
        this.payBtnDisabled = false;
      }).catch(() => {
        this.errorMsgTip = this.$t(`errCode.2`)
        this.currentStep = 4
        this.payBtnDisabled = false;
      });
    },
    PaymentMethodClick(val){
      this.PaymentMethod = val;
      this.rechargingInfo.channel = val;
      // 切换支付方式后重新查询套餐
      this.fetchPackagesAndOpen(this.rechargingInfo);
    },
    // 选择充值支付方式(已合并到step1，直接提交)
    confirmPay() {
      this.payBtnDisabled = false;
      this.conRechargeMethod();
    },
    // 关闭充值弹窗
    closeRechargeDialog() {
      this.showRechargeDialog = false;
    },
    // 查看充值记录
    goRechargeRecord() {
      // this.$router.push({path: '/generalNew/setting/rechargeRecord'});
      this.$router.push({
        path: `/${this.role.group}New/setting/rechargeRecord`
      });
    },
    // 关闭搜索框
    closeSearch() {
      this.showSearch = false;
      this.searchDatalogger.status = "";
      this.searchDatalogger.pn = "";
      this.searchDatalogger.load = "";
      this.searchDatalogger.cardType = "";
      this.searchDatalogger.ccid = "";
      this.searchDatalogger.alias = "";
      this.queryData();
    },
    // closeSearch2() {
    //   this.searchDatalogger.status = '';
    //   this.searchDatalogger.pn = '';
    //   this.searchDatalogger.load = '';
    //   this.searchDatalogger.ccid = '';
    //   this.searchDatalogger.alias = '';
    //   if (this.showSearch) {
    //     this.queryData();
    //   }
    //   this.showSearch = false;
    // },
    showSearchBtn() {
      this.showSearch = true;
      this.$nextTick(() => {
        this.$refs.iptFocus.focus();
      });
    },
    // 关闭批量操作弹条
    closeBatch() {
      this.$refs.multiplePayTable.clearSelection();
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../../assets/css/mixin.less");

.rechargerecordNew {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 20px;
  // background-color: rgb(34, 45, 53);
  overflow: auto;

  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-disable {
    color: rgba(242, 242, 242, 0.5);
    background: rgba(43, 56, 66, 1);
    cursor: not-allowed;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  .ico-recharge {
    background: url(../../../assets/img/general/Icon_Recharge.png);
  }

  .ico {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    vertical-align: middle;
  }

  .section {
    display: flex;
    flex: 1;
    padding: 0px;
    flex-direction: column;
    border-radius: 0px;
    border: none;
    background: rgb(34, 45, 53);
    position: relative;
    overflow: hidden;

    /deep/.el-icon-loading {
      font-size: 28px;
    }

    .search {
      margin: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: rgb(34, 45, 53);

      .search-label {
        display: inline-block;
        color: #ffffff;
        font-weight: bold;
        line-height: 48px;
        font-size: 14px;
        padding-left: 16px;
      }

      /deep/.el-select {
        width: 100px;
        border-right: 1px solid #738089;
      }

      /deep/.el-select:hover {
        background: @primaryColorTransparency30;
      }

      /deep/.el-input {
        width: 100%;
        text-align: center;
      }

      /deep/.el-input__inner {
        background: transparent;
        border: none;
        height: 48px;
        line-height: 48px;
        color: #ffffff;
        padding: 0 16px;
      }

      /deep/.el-input__suffix {
        right: 0px;
      }

      .button {
        height: 48px;
        line-height: 48px;
        padding: 0 25px;
        margin-top: 0px;
        color: @primaryTextColor;
        background: transparent;
        border: none;
      }

      .search-alert {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 48px;
        z-index: 1;
        background: rgb(34, 45, 53);
        display: flex;
        align-items: center;
        justify-content: space-between;
        .searchDiv {
          position: absolute;
          top: 0;
          // left: 0;
          right: 0;
          width: 400px;
          height: 48px;
          z-index: 2;
          background: rgb(34, 45, 53);
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .searchAll {

          // display: flex;
          // align-items: center;
          // justify-content: flex-end;
          /deep/.el-input__inner {
            width: 220px;
            padding-left: 10px;
          }
        }

        .search-device {
          display: inline-block;
          line-height: 48px;
          padding: 0 15px;
          font-size: 14px;
          background: #202D35;
          color: #33FFB6;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        .search-hide {
          display: inline-block;
          // position: absolute;
          // right: -58px;
          line-height: 48px;
          padding: 0 15px;
          font-size: 14px;
          background: #202d35;
          color: #7b8395;
          border-left: 1px solid #7b8395;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        /deep/.el-input {
          flex: 1;
        }

        /deep/.el-input .el-input__clear {
          width: 48px;
          color: #7b8395;
        }

        /deep/.el-input .el-input__clear:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }

        /deep/.el-input .el-input__inner,
        /deep/.el-input .el-input__inner:hover {
          height: 48px;
          border-radius: 0px;
          border: none;
          background: #202d35;
          color: #ffffff;
          padding-left: 40px;
        }

        /deep/.el-input__prefix {
          left: 0px;
        }

        /deep/.el-input__icon {
          width: 40px;
        }

        /deep/.el-input__suffix {
          right: 0px;
        }

        /deep/.el-input__suffix:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }

        /deep/.el-icon-circle-close:before {
          content: "X";
        }

        /deep/.el-input:not(:last-child) {
          margin-right: 0px;
        }
      }
    }

    .tableloding {
      // 加载数据时遮罩
      /deep/.el-loading-mask {
        background-color: rgb(34, 45, 53, 0.5);
      }

      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
      }
    }

    .tablemain {
      border: none;
      background-color: rgb(34, 45, 53);

      .operation i {
        color: @primaryTextColor;
      }

      /deep/.el-table--border::after,
      /deep/.el-table--group::after {
        width: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
        width: 16px;
        height: 16px;
        background: transparent;
        border: 1px solid rgb(180, 184, 193);
        border-radius: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
        top: 2px;
        left: 5px;
      }

      /deep/.el-table__header th {
        height: 48px;
      }

      /deep/.el-table__header th.is-leaf {
        border-color: rgba(198, 209, 221, 0.5);
        // border-bottom: none;
      }

      /deep/.el-table__header th > .cell {
        font-weight: normal;
        font-size: 12px;
      }

      /deep/.el-table__body tr,
      /deep/.el-table__body td {
        background-color: rgb(34, 45, 53);
        color: #ffffff;
        border-color: rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__body td.el-table-column--selection {
        background-color: rgb(65, 80, 90);
        color: #ffffff;
      }

      /deep/.el-table__body .cell.el-tooltip {
        font-size: 14px;
      }

      /deep/.el-table__fixed-right::before,
      /deep/.el-table__fixed::before {
        display: none;
      }

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #222d35;
      }

      // 关于复选框
      /deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      /deep/.el-checkbox
        .el-checkbox__input.is-indeterminate
        .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      // 关于头部右侧空白
      /deep/.el-table__fixed-right-patch {
        background-color: rgb(65, 80, 90);
        border-bottom: none;
      }

      /deep/th.gutter {
        background-color: rgb(65, 80, 90);
      }
    }

    .tablebottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid rgba(198, 209, 221, 0.5);

      // 分页
      .pagination {
        line-height: 48px;
        height: 48px;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 16px;

        /deep/.el-pager li {
          vertical-align: middle;
        }

        /deep/.el-select .el-input {
          width: 90px;
          margin: 0px;
        }

        /deep/.el-input .el-input__inner {
          background-color: #202d35;
          color: #ffffff;
        }

        /deep/.el-input__suffix {
          right: 10px;
        }

        /deep/.el-pagination__sizes {
          margin: 0px;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pagination__total {
          color: #fff;
          padding-left: 15px;
          border-left: 1px solid #7b8395;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pager li:not(.disabled).active {
          // background: #15C491;
          // color: #ffffff;
          background-color: #2b3842;
          color: #15c491;
        }

        // li:not(.disabled):not(.active):hover
        /deep/.el-pager li:not(.disabled):hover {
          background-color: @primaryColorTransparency30;
          color: rgba(255, 255, 255, 1);
        }

        /deep/.el-pager li {
          background-color: #2b3842;
          color: #7b8395;
        }

        // 页条数下拉
        /deep/.el-select .el-input .el-input__inner {
          border: none;
          height: 48px;
          line-height: 48px;
          border-radius: 0px;
        }

        /deep/.el-select .el-input .el-input__inner:hover {
          background: @primaryColorTransparency30;
        }

        // 跳页
        /deep/.el-pagination__jump {
          color: #ffffff;
        }

        /deep/.el-pagination__editor {
          padding: 0px 6px;
        }

        /deep/.el-pagination__editor.el-input .el-input__inner {
          border: 1px solid #7b8395;
        }
      }

      // 分页前后按钮
      /deep/.el-pagination.is-background .btn-next,
      /deep/.el-pagination.is-background .btn-prev {
        background-color: #2b3842;
        color: #7b8395;
      }

      /deep/.el-pagination.is-background .btn-next:hover,
      /deep/.el-pagination.is-background .btn-prev:hover {
        background-color: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      /deep/.el-pagination.is-background button[disabled],
      /deep/.el-pagination.is-background button[disabled]:hover {
        background-color: #2b3842;
        color: #7b8395;
      }
    }
  }

  // 充值对话框
  .dialog-recharge {
    .dialog-outborder {
      width: 708px;
    }

    .dialog-footer {
      .button-hollow,
      .button-hollow:hover {
        background: transparent;
        color: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }
    }

    // 步骤
    .step-one {
      .tag {
        height: 40px;
        line-height: 38px;
        margin-right: 10px;
        border-radius: 4px;
        border: 1px solid rgba(204, 206, 221, 1);
        background: rgba(43, 56, 66, 1);
        color: rgba(242, 242, 242, 1);
        font-size: 16px;
      }

      .package {
        display: inline-block;
        padding: 7px 0;
        width: 110px;
        border-radius: 6px;
        margin: 0 10px 10px 0;
        text-align: center;
        // line-height: 1.3;
        // border: 1px solid @borderColor;
        border: none;
        cursor: pointer;
        background: rgba(43, 56, 66, 1);
        color: rgb(123, 131, 149);
        font-size: 16px;

        &:hover {
          // color: @themeColor;
          // border-color: @themeColor;
          color: @primaryTextColor;
        }

        &.selected {
          // border-color: transparent;
          // color: #fff;
          // background: @themeBg;
          color: @primaryTextColor;
        }
      }

      // 充值套餐（删）
      // .packagebox {
      //   /deep/.el-radio-button {
      //     &.is-active {
      //       span {
      //         color: @primaryTextColor;
      //       }
      //     }
      //   }
      //   /deep/.el-radio-button__orig-radio:checked+.el-radio-button__inner {
      //     box-shadow: none;
      //   }
      //   /deep/.el-radio-button__inner {
      //     display: flex;
      //     flex-direction: column;
      //     justify-content: space-between;
      //     align-items: center;
      //     background: rgba(43, 56, 66, 1);
      //     color: rgb(123, 131, 149);
      //     border: none;
      //     border-radius: 6px;
      //     width: 100px;
      //     height: 74px;
      //     font-size: 16px;
      //     margin-bottom: 10px;
      //     margin-right: 10px;
      //   }
      // }
      // 结算信息
      .settlementbox {
        // width: 620px;
        // height: 192px;
        width: 100%;
        height: auto;
        border-radius: 6px;
        background: rgba(43, 56, 66, 1);
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px;

        .settlementinfo {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          padding-left: 16px;

          .settlementnum {
            font-size: 16px;
            margin-bottom: 10px;
          }

          .settlementscan {
            color: rgba(51, 255, 182, 1);
            font-size: 20px;
            margin-bottom: 10px;
          }

          .settlementtip {
            color: rgba(255, 62, 62, 1);
            font-size: 12px;
          }
        }
      }

      .capsule-wrapper {
        display: inline-block;
        width: 150px;
        height: 60px;
        padding: 2px;
        background: @borderColor;
        margin-right: 10px;
        border-radius: 5px;
        cursor: pointer;

        &.selected {
          background: @themeBg;
        }

        .capsule-content {
          background: #fff;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 5px;
        }
      }

      .discount {
        .sc(20px, @normalColor);
      }

      .price {
        .sc(20px, @themeColor);
      }

      /deep/.el-form-item__label {
        line-height: 38px;
        color: #ffffff;
      }

      // 支付方式横排
      .payment-method-row {
        display: flex;
        gap: 16px;
      }
      .payment-method-card {
        display: flex;
        align-items: center;
        padding: 12px 20px;
        background: rgba(43, 56, 66, 1);
        border-radius: 6px;
        cursor: pointer;
        border: 1px solid transparent;
        &.active {
          border-color: @primaryTextColor;
        }
        .payment-icon {
          width: 48px;
          height: 48px;
          border-radius: 8px;
          margin-right: 12px;
          object-fit: contain;
        }
        .payment-info {
          display: flex;
          flex-direction: column;
          .payment-name {
            display: flex;
            align-items: center;
            font-size: 16px;
            color: #fff;
            .paybaseShow {
              width: 18px;
              height: 18px;
              box-sizing: border-box;
              display: inline-block;
              background-repeat: no-repeat;
              background-position: 50%;
              border-radius: 50%;
              border: 2px solid #333333;
              background-color: rgba(26, 92, 107, 1);
              margin-left: 10px;
            }
            .payChoose {
              border: 2px solid #333333;
              background-color: rgba(26, 92, 107, 1);
              background-image: url(../../../assets/img/recharge/check.png);
              background-size: 10px 10px;
            }
          }
          .payment-desc {
            font-size: 12px;
            margin-top: 6px;
            color: rgba(255, 255, 255, 0.5);
          }
        }
      }
    }

    .step-common {
      padding: 40px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .step-two {
      .step-common;

      .prompt {
        .sc(14px, #fff);
      }

      .price {
        // .sc(26px, @themeColor);
        .sc(26px, rgba(51, 255, 182, 1));
        line-height: 1.6;
      }

      .qr {
        width: 180px;
        height: 180px;
        margin: 10px 0 15px;
      }

      .info {
        .sc(16px, rgba(51, 255, 182, 1));
        line-height: 1.4;
      }
    }

    .step-three {
      .step-common;

      i {
        .sc(200px, @themeColor);
      }

      .prompt {
        .sc(30px, #333);
      }

      .info {
        margin-top: 20px;
        .sc(16px, #333);
      }
    }
    .step-four {
      text-align: center;
    .paymentMethodItem{
      display: flex;
      align-items: center;
      padding: 20px;
      border-bottom: 1px solid #116863;    
      cursor: pointer;
      .rightContent{
        display: flex;
        flex-direction: column;
        height: 70px;    
        margin-left: 30px;
        .weixinHeard{
          height: 30px;
          display: flex;
          align-items: center;
        }
      }
      }
      .paybaseShow{
        width: 24px;
        height: 24px;
        box-sizing: border-box;
        display: inline-block;
        background-repeat: no-repeat;
        background-position: 50%;
        border-radius: 50%;
        border: 2px solid #333333;;
        background-color: rgba(26, 92, 107, 1);
        margin-left: 20px;
      }
      .weixinPayTip{
        font-size: 16px; 
        margin-top: 15px;
        text-align: left;
        color: rgba(255, 255, 255, 0.556862745098039);
      }
      .payChoose{
        border: 2px solid #333333;;
        background-color: rgba(26, 92, 107, 1);
        background-image: url(../../../assets/img/recharge/check.png);
        background-size: 14px 14px;
      }
      .showresultbtn {
            //width: 102px;
            padding: 0 10px;
            height: 30px;
            margin-top: 10px;
            border-radius: 6px;
            background: @primaryTextColor;
            color: rgba(34, 45, 53, 1);
            font-size: 14px;
          }
    }

    .step-two,
    .step-three {
      // 充值结果提示
      .showresultbox {
        display: flex;
        flex-direction: column;
        align-items: center;

        .showsuccess {
          border: 3px solid rgba(37, 255, 174, 1);
          background-color: rgba(19, 195, 156, 1);
          background-image: url(../../../assets/img/general/Icon_Finished.png);
          background-size: 70px 70px;
        }

        .showfail {
          border: 3px solid rgba(246, 189, 189, 1);
          background: rgba(251, 75, 75, 1);
          background-image: url(../../../assets/img/general/Icon_Failed.png);
          background-size: 120px 120px;
        }

        .showbase {
          width: 100px;
          height: 100px;
          box-sizing: border-box;
          background-repeat: no-repeat;
          background-position: center;
          border-radius: 50%;
        }

        .showresultname {
          font-weight: bold;
          font-size: 18px;
          line-height: 36px;
          margin-top: 30px;
          color: rgba(255, 255, 255, 1);
        }

        .showresulttip {
          color: rgba(255, 255, 255, 0.7);
          font-size: 14px;
          margin-top: 18px;
        }

        .showresulttext {
          font-weight: bold;
          font-size: 18px;
          margin-top: 20px;
          margin-bottom: 30px;
          color: rgba(255, 255, 255, 1);
        }

        .showoperate {
          text-align: center;
        }

        .showresultbtn {
          // width: 102px;
          padding: 0 10px;
          height: 30px;
          margin-top: 10px;
          border-radius: 6px;
          background: @primaryTextColor;
          color: rgba(34, 45, 53, 1);
          font-size: 14px;
        }
      }
    }
  }

  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background-color: #222d35;
  }

  // 批量操作弹条
  .batch-alert {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 48px;
    z-index: 1;
    background: rgba(255, 231, 107, 1);
    display: flex;
    align-items: center;
    justify-content: space-between;

    .batch-total {
      padding-left: 16px;
      font-size: 14px;
    }

    .batch-right {
      display: flex;
      justify-content: flex-end;
    }

    .batch-hide {
      height: 48px;
      line-height: 48px;
      padding: 0px 16px;
      cursor: pointer;
      font-size: 14px;

      &:hover {
        background: rgba(255, 255, 255, 1);
      }
    }

    .batch-operate {
      display: flex;
      justify-content: flex-end;

      .btn {
        color: rgba(34, 45, 53, 1);
        font-size: 14px;
        cursor: pointer;
        // display: inline-block;
        height: 48px;
        line-height: 48px;
        padding: 0px 16px;
        border-radius: 0px;
        display: flex;
        align-items: center;

        &:hover {
          background: rgba(255, 255, 255, 1);
        }
      }

      .ico-copy {
        background: url(../../../assets/img/general/Icon_Batch_Copy.png);
      }

      .ico-export {
        background: url(../../../assets/img/general/Icon_Batch_Export.png);
      }

      .ico-clear {
        background: url(../../../assets/img/general/Icon_Batch_Delete.png);
      }

      .ico-pay {
        background: url(../../../assets/img/general/Icon_Batch_Pay.png);
      }

      .ico-more {
        background: url(../../../assets/img/general/Icon_Batch_More.png);
      }

      .ico {
        display: inline-block;
        width: 16px;
        height: 16px;
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
        margin-left: 8px;
      }

      // 批量更多下拉 (不可scoped)(.dropdown-more)
    }
  }
}
</style>
<style lang="less">
// #下拉选框 el-select#
.select-search-recharge {
  background-color: rgb(34, 45, 53);
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border-radius: 4px;
  border: none;
  padding: 8px 0px;

  .el-select-dropdown__list {
    padding: 0px;
  }

  .el-select-dropdown__item {
    padding: 0px 16px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
    min-width: 130px;
  }

  .el-select-dropdown__item.hover {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
  }

  .el-select-dropdown__item.selected {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item:hover {
    padding: 0px 16px;
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.selected .select-label {
    padding: 0px;
  }

  // 对号
  .el-select-dropdown__item.selected:before,
  .el-select-dropdown__item.selected .select-label:before,
  .el-select-dropdown__item.selected.choose-num:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    position: absolute;
    top: 8px;
    right: 16px;
  }

  &[x-placement^="top"] .popper__arrow {
    display: none;
  }
}

// #分页下拉框#
.select-page {
  background-color: rgb(34, 45, 53);
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border-radius: 12px;
  border: none;
  padding: 8px 0px;

  .el-select-dropdown__list {
    padding: 0px;
    background-color: rgb(34, 45, 53);
  }

  .el-select-dropdown__item {
    padding: 0px 16px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
    min-width: 110px;
  }

  .el-select-dropdown__item.hover {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
  }

  .el-select-dropdown__item.selected {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item:hover {
    padding: 0px 16px;
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.selected .select-label {
    padding: 0px;
  }

  // 对号
  .el-select-dropdown__item.selected:before,
  .el-select-dropdown__item.selected .select-label:before,
  .el-select-dropdown__item.selected.choose-num:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    position: absolute;
    top: 8px;
    right: 16px;
  }

  &[x-placement^="top"] .popper__arrow {
    display: none;
  }
}

.rechargerecord {
  .el-popper .popper__arrow,
  .el-popper .popper__arrow::after {
    display: none;
  }
}

.rechargerecordNew {
  .el-table--border::after,
  .el-table--group::after {
    display: none;
  }
}
</style>

<style lang="less" scoped>
//
/deep/.el-message-box {
  background-color: #222d35;
  color: #fff;
}
/deep/.el-notification {
  background-color: #222d35;
  /deep/.el-notification__title {
    color: #fff;
    /deep/.el-notification__content {
      color: #fff;
    }
  }
}
</style>